import * as React from "react";
import Layout from "../../../components/Layout/Layout";
import { StaticImage } from "gatsby-plugin-image";
import Therapist from "../../../components/Therapist/Therapist";

// markup

const name = "Christine Ellis";
const license = "MSW, CSW-PIP";
const areas = [
  "Anxiety",
  "Depression",
  "PTSD",
  "Sexual Orientation",
  "Gender Identity",
  "Trauma",
  "Abuse",
  "Grief and Loss",
  "ADD/ADHD",
  "Blended Family Issues",
];

const IndexPage = () => (
  <Layout full={true} removeTopSpace={true} className="bg-yellow-50 therapists">
    <Therapist
      name={name}
      license={license}
      subtitle="Adolescents, families, trauma, orientation/identity"
      areas={areas}
      photo={
        <StaticImage
          src="./christine-ellisv2.jpg"
          alt={name}
          layout="constrained"
          className="shadow"
        />
      }
    >
      <p>
        Christine earned her social work degree in 1994 and began her career in
        residential treatment settings supporting youth ages 10–18. After
        completing her Master of Social Work in 2000, she provided home-based
        therapy through the community mental health center serving children and
        teens ages 4–18 who were referred by schools, Court Services, the
        Department of Social Services, the Department of Corrections, and other
        health care providers.
      </p>

      <p>
        In 2006, Christine worked as a hospice social worker, providing
        end-of-life support for individuals of all ages and facilitating grief
        support groups for families and caregivers. She joined Integrative
        Wellness in 2007 and now sees adolescents, adults, and families in
        private practice. Christine offers a supportive, practical approach
        grounded in her extensive experience helping clients navigate anxiety,
        depression, trauma, grief, identity concerns, and family transitions.
      </p>

      <p>
        A lifelong Sioux Falls resident, Christine values community, and
        connection. Outside of work, she enjoys long-distance running, camping,
        cooking, and spending time with her family and pets.
      </p>
    </Therapist>
  </Layout>
);

export default IndexPage;
